package com.essntl.features.service.ui.addeditservice.components

import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.essntl.features.service.ui.addeditservice.AddEditServiceEvent
import com.essntl.features.service.ui.addeditservice.AddEditServiceState
import com.essntl.features.service.ui.addeditservice.EditServiceSectionData
import com.essntl.uikit.components.input.EsInput

@Composable
fun InternalNotesItem(
    state: AddEditServiceState,
    onEvent: (AddEditServiceEvent) -> Unit,
    enabled: Boolean,
) {
    EsInput(
        value = state.service.value.internalNotes ?: "",
        onValueChange = {
            onEvent(
                AddEditServiceEvent.UpdateServiceFields(
                    state.service.value.copy(
                        internalNotes = it,
                    ),
                ),
            )
        },
        label = "Internal notes",
        singleLine = false,
        placeholder = "Enter notes",
        enabled = enabled,
        modifier = Modifier
            .fillMaxWidth(),
    )
}